/* eslint-disable no-unused-vars */
import axios from "axios";
import swal from "sweetalert";
import config from "../../config.json";

export async function updateImageUser(file) {
  try {
    const token = localStorage.getItem("tokenLogin");
    if (!token) throw { message: "Utilisateur non connecté" };

    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.put(
      `${config.dev}/user/update-image`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // { message, imageUrl }
  } catch (err) {
    console.error(err);
    throw err.response?.data || { message: err.message || "Erreur serveur" };
  }
}
